@if (showNavItems) {
	<div class="d-none d-sm-block">
		<div class="d-flex flex-row nav-heading-wrapper" data-cy="nav-heading">
			<div class="col d-none d-sm-block">
				<ea-header
					[productName]="weProductName"
					id="tardy"
					data-cy="tuition-product-header-text"
				></ea-header>
			</div>
			<div class="col d-flex justify-content-end">
				<div class="d-flex align-items-center icons-wrapper">
					@if (isSiteRedesignFeatureEnabled && isNotificationsEnabled) {
						<button
							(keydown)="handleKeydown()"
							[ngbTooltip]="showNotificationsTooltip && notificationsTooltip"
							[attr.aria-label]="notificationsAriaLabel"
							class="notification-wrapper nav-icon aut-notifications-icon"
							(click)="openNotifications()"
							data-cy="notifications-icon"
						>
							<i class="fa fa-lg fa-bell fa-stack-1x fa-inverse nav-icon"></i>
							@if (unreadCountTotal) {
								<span
									class="notification-count"
									data-cy="notifications-count-icon"
									>{{ unreadCountTotal }}</span
								>
							}
						</button>
					}
					@if (showSupportServices) {
						<tu-support-services
							class="ml-2 nav-icon aut-support-services-icon"
							data-cy="support-services-icon"
						></tu-support-services>
					}
					<tu-other-services
						class="ml-2 nav-icon aut-other-services-icon"
						data-cy="other-services-icon"
					></tu-other-services>
					<tu-profile-actions
						class="ml-2 nav-icon aut-profile-icon"
						data-cy="profile-icon"
					></tu-profile-actions>
				</div>
				<ea-client-logo class="d-flex align-items-center"></ea-client-logo>
			</div>
		</div>
		@if (navbarItems?.length) {
			<ea-navbar
				ariaLabel="Tuition Main"
				[items]="navbarItems"
				data-cy="tuition-main-navigation"
			>
				@if (!isFranchiseOperator) {
					<tu-start-application-button
						buttonText="New Application"
						(startApplicationButtonClick)="navigateToFastTrackFlow()"
						class="aut-new-app-btn"
						data-cy="navbar-new-application-button"
					>
					</tu-start-application-button>
				}
			</ea-navbar>
		}
	</div>
}
<ng-template #notificationsTooltip> Notifications </ng-template>
